/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatRequest } from '../../models/chat-request';
import { ChatResponse } from '../../models/chat-response';

export interface Chat$Params {
  'x-api-requestId'?: string;
  'x-api-canal'?: string;
      body: ChatRequest
}

export function chat(http: HttpClient, rootUrl: string, params: Chat$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatResponse>> {
  const rb = new RequestBuilder(rootUrl, chat.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChatResponse>;
    })
  );
}

chat.PATH = '/v1/api/ui/ecom/chat';
